// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Popup_wrapper__49p1B","box":"Popup_box__3TN9I","header":"Popup_header__2BeAJ","title":"Popup_title__1QHg_","close":"Popup_close__1o3xF","body":"Popup_body__1Zc7M"};